@if(routerLink) {
<a [class]="'btn-tc' + ' ' + hierarchyClass + ' ' + sizeClass" [ngClass]="{'btn-has-one-icon': hasOneIcon, 'radius-full': isRound, 'btn-just-icon':isJustIcon,'btn-destructive': isDestructive,
        'disabled':isDisabled,'btn-warning': isWarning
    }" mat-flat-button [attr.mat-button]="attributeVariantsType === attributeType.Base"
    [attr.mat-flat-button]="attributeVariantsType === attributeType.Flat" [routerLink]="routerLink"
    [attr.mat-stroked-button]="attributeVariantsType === attributeType.Stroked" [disableRipple]="true" appMousePress
    (click)="submit()" [disabled]="isDisabled">
    <ng-content select="[dataBtnLink]"></ng-content>
</a>
} @else {
<button [type]="btnType" [class]="'btn-tc' + ' ' + hierarchyClass + ' ' + sizeClass"
    [ngClass]="{'is-loading': isLoading, 'btn-has-one-icon': hasOneIcon, 'radius-full': isRound, 'btn-just-icon':isJustIcon,'btn-destructive': isDestructive,'btn-warning': isWarning}"
    mat-flat-button [attr.mat-button]="attributeVariantsType === attributeType.Base"
    [attr.mat-flat-button]="attributeVariantsType === attributeType.Flat"
    [attr.mat-stroked-button]="attributeVariantsType === attributeType.Stroked" [TcPromise]="submitSubscription"
    [disableRipple]="true" appMousePress (click)="submit()" [disabled]="isDisabled || isLoading">
    <ng-content select="[dataBtn]"></ng-content>
</button>
}